export const aboutImages = {
  hero: 'https://public.readdy.ai/ai/img_res/sandbox/83fb63f3ff354beee53a36a8b9d2436f/8f439bde-7106-4b82-bc85-380db0f19be7_cleary-about-hero.webp',
  approach: 'https://public.readdy.ai/ai/img_res/sandbox/83fb63f3ff354beee53a36a8b9d2436f/8f439bde-7106-4b82-bc85-380db0f19be7_cleary-about-approach.webp',
  team: 'https://public.readdy.ai/ai/img_res/sandbox/83fb63f3ff354beee53a36a8b9d2436f/8f439bde-7106-4b82-bc85-380db0f19be7_cleary-about-team.webp',
};



export const principles = [
  { num: '01', title: 'Attention to Detail', text: 'We take a considered approach to each room, including the small areas that are easy to overlook.' },
  { num: '02', title: 'Respect for Your Space', text: 'Your home is personal. We treat your belongings and routines with care and consideration.' },
  { num: '03', title: 'Clear Communication', text: 'Straightforward plans and open conversation, so you know what to expect before every clean.' },
];

export const philosophy = [
  { title: 'Thoughtful Preparation', text: 'Understanding your home and priorities before the cleaning begins.' },
  { title: 'Consistent Attention', text: 'Bringing the same level of care to every visit and every room.' },
  { title: 'Practical Cleaning Methods', text: 'Sensible, methodical techniques suited to everyday residential spaces.' },
  { title: 'Customer-Focused Communication', text: 'Listening to your preferences and keeping conversations simple and clear.' },
];